"use client";

import Link from "next/link";
import { useRouter } from "next/navigation";
import { useRef, type ComponentProps } from "react";

// Link de produto com prefetch só na INTENÇÃO (2026-10-24): ao passar o
// mouse, tocar ou focar. Antes, cada card de produto usava prefetch={true},
// que baixa a página inteira de TODOS os produtos visíveis assim que entram
// na tela (na home eram ~25 páginas, ~380 KB, e segundos de processamento no
// celular, travando a página). Agora só o produto em que o cliente vai
// clicar é preparado, e a navegação continua rápida.

type IntentPrefetchLinkProps = Omit<ComponentProps<typeof Link>, "href" | "prefetch"> & { href: string };

export function IntentPrefetchLink({ href, onPointerEnter, onTouchStart, onFocus, ...props }: IntentPrefetchLinkProps) {
  const router = useRouter();
  const done = useRef(false);
  const prefetch = () => {
    if (done.current) return;
    done.current = true;
    router.prefetch(href);
  };
  return (
    <Link
      {...props}
      href={href}
      prefetch={false}
      onPointerEnter={(event) => { prefetch(); onPointerEnter?.(event); }}
      onTouchStart={(event) => { prefetch(); onTouchStart?.(event); }}
      onFocus={(event) => { prefetch(); onFocus?.(event); }}
    />
  );
}
